import {state} from '@/core/store/comum'

function possuiAcesso(permissoesUsuario = [], permissoesNecessarias = []) {

    if (!permissoesNecessarias.length) {
        return true
    }
    return permissoesNecessarias.some(permissao =>
        permissoesUsuario.includes(permissao)
    )
}

export default function (permissoesNecessarias = []) {
    const usuario = state.comum.usuarioLogado || {}
    const permissoesUsuario = usuario.permissao || []

    return possuiAcesso(permissoesUsuario, permissoesNecessarias)
}